import React from 'react';
import './DateFilter.css';

export type DateField = 'dateStart' | 'dateEnd' | 'deadline';
export type Comparator = '=' | '>' | '<' | '>=' | '<=';

interface DateFilterProps {
  date: string;
  field: DateField;
  comparator: Comparator;
  onDateChange: (date: string) => void;
  onFieldChange: (field: DateField) => void;
  onComparatorChange: (comparator: Comparator) => void;
}

const DateFilter: React.FC<DateFilterProps> = ({
  date,
  field,
  comparator,
  onDateChange,
  onFieldChange,
  onComparatorChange,
}) => {
  return (
    <div className="date-filter">
      <label className="filter-label">Filter Time Sheets</label>
      <div className="filter-row">
        <select
          className="filter-select field-select"
          value={field}
          onChange={(e) => onFieldChange(e.target.value as DateField)}
        >
          <option value="dateStart">Date Start</option>
          <option value="dateEnd">Date End</option>
          <option value="deadline">Deadline</option>
        </select>

        <select
          className="filter-select comparator-select"
          value={comparator}
          onChange={(e) => onComparatorChange(e.target.value as Comparator)}
        >
          <option value="=">=  (equals)</option>
          <option value=">=">≥ (greater or equal)</option>
          <option value="<=">≤ (less or equal)</option>
          <option value=">">&gt; (greater than)</option>
          <option value="<">&lt; (less than)</option>
        </select>

        <input
          type="date"
          className="filter-date"
          value={date}
          onChange={(e) => onDateChange(e.target.value)}
        />
      </div>
    </div>
  );
};

export default DateFilter;
